import PropTypes from "prop-types";
import React from "react";
import "./SpeedGauge.css";
import { useEffect, useState } from "react";

export default function SpeedGauge({ value, denominator }) {
  // console.log("Value:", value);
  return (
    <div className="gauge-display">
      <div className="gauge">
        <div className="max-range" style={{ height: `${denominator * 80}px` }}>
          <div className="current-value" style={{ height: `${value * 80}px` }}>
            {/* <input value={value} max={1} min={0} readOnly></input> */}
          </div>
        </div>
        {/* <svg width={"9em"} style={{ border: "1px solid pink" }}></svg> */}
      </div>
    </div>
  );
}
